/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import ExpandableContent from 'shared/ui/components/ExpandableContent.vue';
import DataTypes from 'docs/components/apis/DataTypes.vue';
import Parameters from 'docs/components/apis/Parameters.vue';
import Responses from 'docs/components/apis/Responses.vue';

/**
 * This component is used to display the list of API methods for a specific route.
 * Every method (or verb), shows also its details when expanded.
 *
 * @vue-prop {String} baseUrl the base URL to perform the call to
 * @vue-prop {Object} route the route details to render as specified by Open API contract
 * @vue-prop {String} path the path of the API
 * @vue-prop {Object} [definitions] an optional list of objects definitions
 *
 * @category docs.components.apis
 * @exports ApiPath
 * @component
 */
const __vue_script__ = {
    name: 'ApiPath',

    components: {
        ExpandableContent,
        DataTypes,
        Parameters,
        Responses
    },

    props: {
        baseUrl: {
            type: String,
            required: true
        },

        route: {
            type: Object,
            required: true
        },

        path: {
            type: String,
            required: true
        },

        definitions: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            url: this.baseUrl + this.path
        };
    },

    methods: {
        onCopy() {
            this.$notify({
                group: 'flashes',
                text: this.$i18n.t('api_docs.url_copied').toString(),
                type: 'success'
            });
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"api-path"},_vm._l((_vm.route),function(details,verb){return _c('expandable-content',{staticClass:"unlimited-height path-info",class:verb,attrs:{"clickable-header":true},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var isOpen = ref.isOpen;
return [(isOpen)?_c('div',{staticClass:"details"},[_c('pre',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:(_vm.$t('api_docs.base_url_tooltip')),expression:"$t('api_docs.base_url_tooltip')",modifiers:{"bottom":true}},{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.url),expression:"url",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.onCopy),expression:"onCopy",arg:"success"}],staticClass:"base-url"},[_vm._v(_vm._s(_vm.url))]),_c('vue-markdown',{staticClass:"description"},[_vm._v(_vm._s(details.description))]),_c('data-types',{attrs:{"consumes":details.consumes,"produces":details.produces}}),_c('parameters',{attrs:{"params":details.parameters,"definitions":_vm.definitions}}),_c('responses',{attrs:{"responses":details.responses,"definitions":_vm.definitions}})],1):_vm._e()]}}],null,true)},[_c('div',{staticClass:"heading",attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"verb"},[_vm._v(_vm._s(verb))]),_c('div',{staticClass:"path"},[_vm._v(_vm._s(_vm.path))])])])}),1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ApiPath.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__